import { IGRNUpdatePutBody } from "@/api_framework/api_modals/Inventory";
import ModalPrompt from "@/app/components/ui/Modals/Prompt";
import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import { useState } from "react";
// import { useModalState } from "@/app/hooks/ui_hooks/useModalState";

export interface IGRNStatusModalState {
  GRNUpdatePayload: IGRNUpdatePutBody;
}

interface IGRNStatusModalProps {
  onSubmit: () => Promise<void>;
}

const GRNStatusModal: React.FC<IGRNStatusModalProps> = ({ onSubmit }) => {
  const { setInvisible } = useModalActions("GRN_STATUS_UPDATE");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // const { GRNUpdatePayload } = useModalState("GRN_STATUS_UPDATE") as IGRNStatusModalState;
  const handleReceiveGoods = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      await onSubmit();
      setInvisible();
    } catch (err) {
      console.error("Error in Receive Goods:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ModalPrompt
      modalId="GRN_STATUS_UPDATE"
      title="Move Goods From Pending To Done ?"
      content={
        <div className="text-gray-600 text-xs">
          <p>
            Are you sure ? The selected Products / Goods will be marked as{" "}
            <span className="font-semibold text-green-600">Done</span>.
          </p>

          {/* <ol className="mt-2 list-disc">
            {GRNUpdatePayload?.pending_grn?.map((product) => {
              return (
                <li key={product.variant_id} className="font-semibold">
                  {product.variant_name}
                </li>
              );
            })}
          </ol> */}
        </div>
      }
      button={{
        primaryButtonText: "Receive Goods",
        primaryButtonClassname: isSubmitting ? "bg-gray-400 cursor-not-allowed" : "bg-green-500",
        primaryCallback: handleReceiveGoods,
        shouldHideOnClick: true,
        secondaryButtonText: "Cancel",
      }}
    />
  );
};

export default GRNStatusModal;
